// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1qDis","tab":"Tabs_tab__2rXs8","tabActive":"Tabs_tabActive__Lo5p2"};